import React from 'react';
import { Grid, Typography } from '@mui/material';

import FlightItineraryDetail from '@FlightsComponents/FlightItineraryDetail';
import { CustomDialogModal } from '@shared/components/Dialogs';

const formatCity = str => str?.replaceAll(/\b\w/g, c => c.toUpperCase());

const formatRoute = route => route?.split(' - ').map(formatCity).join(' - ');

const FlightItineraryModal = ({ isOpen, onClose, cluster = {} }) => {
  return (
    <CustomDialogModal open={isOpen} onClose={onClose} showCerrar={true} narrow>
      <Grid
        container
        item
        style={{
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '2rem',
        }}
      >
        {cluster?.legs?.map((leg, index) => {
          return (
            <React.Fragment key={leg.hash + '-itinerary-' + index}>
              <Grid item xs={12}>
                <Grid container spacing={{ xs: 0, md: 2 }} sx={{ mb: 1 }}>
                  {/* IZQUIERDA: título + fecha */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: '#000',
                        textAlign: 'left',
                        fontSize: { xs: '14px', md: '16px', lg: '18px' },
                      }}
                    >
                      {leg.title + ' ' + leg.date?.replace(/ de \d{4}$/, '')}
                    </Typography>
                  </Grid>

                  {/* DERECHA: ruta */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: '#000',
                        textAlign: { xs: 'left', md: 'right' },
                        fontSize: { xs: '14px', md: '16px', lg: '18px' },
                      }}
                    >
                      {formatRoute(leg.origin_destination)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <FlightItineraryDetail
                  flights={leg.options?.[0]?.flights}
                  id_option={leg.options?.[0]?.id_option}
                />
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    </CustomDialogModal>
  );
};

export default FlightItineraryModal;
